<template>
  <div :class="`${$style.vipPage} ${hiddenTitle ? $style.hiddenTitle : ''}`">
    <header>
      <div @click="closePage">
        <i class="iconfont yw-xiangzuo"></i>
      </div>
      <span>{{ pageTitle || "游戏预约" }}</span>
    </header>
    <div
      v-if="showDownLoadApp && subscribeDetail.appStatus == 1"
      :class="$style.download"
    >
      <img
        :src="`${cdnLink}/download/btIcon.png`"
        :class="$style.hot"
        loading="lazy"
      />
      <p style="flex: 1">下载变态猫游戏查看更多好游</p>
      <p @click="onDownloadWX">立即下载></p>
    </div>
    <div v-if="isWeChat" :class="$style.dialogMask" @click="isWeChat = false">
      <img
        :src="`${cdnLink}/box_subscribe/wxGuide.jpg`"
        :class="$style.wxGuide"
        loading="lazy"
      />
    </div>
    <PullRefresh
      v-model="isLoading"
      success-text="刷新成功"
      @refresh="onRefresh"
    >
      <!-- 活动未开始 -->
      <div
        v-if="subscribeDetail.status === 1"
        :class="`${$style.pageBg} ${
          showDownLoadApp && subscribeDetail.appStatus == 1
            ? $style.pageMt
            : null
        }`"
      >
        <img :src="`${cdnLink}/box_subscribe/unStart.png`" />
        <div :class="$style.pageStatus">活动未开始</div>
      </div>

      <!-- 活动进行中 -->
      <div
        v-if="subscribeDetail.status === 2"
        :class="`${
          showDownLoadApp && subscribeDetail.appStatus == 1
            ? $style.pageMt
            : null
        }`"
      >
        <div :class="$style.gameBox">
          <div
            :class="$style.gameListMask"
            :style="{
              backgroundImage: `url(` + subscribeDetail.banner + `)`,
            }"
          ></div>
          <div :class="$style.gameInfo">
            <img
              :class="$style.img"
              :src="subscribeDetail.gameIcon"
              loading="lazy"
            />
            <div :class="$style.wrapper">
              <p :class="$style.title">{{ subscribeDetail.appName }}</p>
              <img
                :src="`${cdnLink}/box_subscribe/hot.png`"
                :class="$style.hot"
                loading="lazy"
              />
              <span :class="$style.num"
                >{{ subscribeDetail.appPeopleNum }}人已{{
                  subscribeDetail.gameStatus === 0 ? "预约" : "下载"
                }}</span
              >
            </div>
            <div
              v-if="subscribeDetail.gameStatus === 0"
              :class="`${$style.btn} ${this.mobile ? $style.disableBtn : ''}`"
              @click="onOpenOrderDialog(0)"
            >
              {{ this.mobile ? "已预约" : "预约" }}
            </div>
            <div
              v-if="subscribeDetail.gameStatus === 1"
              :class="$style.btn"
              @click="onDownloadGame(0)"
            >
              下载游戏
            </div>
          </div>
        </div>
        <div :class="$style.detailInfo">
          <div v-if="subscribeDetail.gameStatus === 0" :class="$style.timeBox">
            <img
              :class="$style.iconImg"
              :src="`${cdnLink}/box_subscribe/date.png`"
            />
            <p :class="$style.desc">预计上线时间：{{ formatOnlineTime }}</p>
            <p :class="$style.day">距上线：{{ subscribeDetail.toDays }}天</p>
          </div>
          <div
            v-if="subscribeDetail.noticeStatus === 1 && subscribeDetail.title"
            :class="$style.noticeBox"
          >
            <img
              :class="$style.iconImg"
              :src="`${cdnLink}/box_subscribe/notice.png`"
            />
            <p
              :class="$style.desc"
              @click="onJumpLink('btNoticeDetail', subscribeDetail.noticeId)"
            >
              {{ subscribeDetail.title }}
            </p>
            <p
              :class="$style.allNotice"
              @click="onJumpLink('btNoticeList', pid)"
            >
              查看全部公告
            </p>
          </div>
        </div>

        <div :class="$style.pageContent">
          <SectionTitle title="预约福利" />
          <div :class="`${$style.giftHeader}`">
            <img
              :src="
                subscribeDetail.giftIcon
                  ? subscribeDetail.giftIcon
                  : `${cdnLink}/box_subscribe/giftIcon.png`
              "
              loading="lazy"
            />
            <div :class="$style.flex_1">
              <p :class="$style.name">{{ subscribeDetail.giftName }}</p>
              <p :class="$style.desc">
                {{
                  subscribeDetail.gameStatus === 1
                    ? "预约用户已开放领取"
                    : "预约游戏上线后即可领取"
                }}
              </p>
            </div>
            <div
              v-if="subscribeDetail.gameStatus === 1"
              :class="$style.btn"
              @click="onReceiveGift"
            >
              {{ giftInfo ? "已" : "" }}领取
            </div>
          </div>
          <p :class="$style.giftTitle">礼包内容</p>
          <p
            :class="$style.giftContent"
            v-html="
              subscribeDetail.giftInfo
                ? subscribeDetail.giftInfo.replace(/(\r\n|\n|\r)/gm, '<br />')
                : ''
            "
          ></p>

          <SectionTitle title="游戏介绍" />
          <div :class="$style.gameImages">
            <img
              v-for="(url, index) in subscribeDetail.images"
              :key="url + index"
              :src="url"
              :class="
                subscribeDetail.imageStyle === 2 ? $style.image : $style.imageL
              "
            />
          </div>
          <p
            :class="$style.giftContent"
            v-html="
              subscribeDetail.gameInfo
                ? subscribeDetail.gameInfo.replace(/(\r\n|\n|\r)/gm, '<br />')
                : ''
            "
          ></p>
        </div>

        <div
          v-if="subscribeDetail.gameStatus === 0"
          :class="`${$style.footerBtn} ${this.mobile ? $style.disableBtn : ''}`"
          @click="onOpenOrderDialog(1)"
        >
          {{ this.mobile ? "已预约" : "预约" }}
        </div>
        <div
          v-if="subscribeDetail.gameStatus === 1"
          :class="`${$style.footerBtn}`"
          @click="onDownloadGame(1)"
        >
          下载游戏
        </div>
      </div>

      <!-- 活动已结束 -->
      <div
        v-if="subscribeDetail.status === 3"
        :class="`${$style.pageBg} ${
          showDownLoadApp && subscribeDetail.appStatus == 1
            ? $style.pageMt
            : null
        }`"
      >
        <img :src="`${cdnLink}/box_subscribe/end.png`" />
        <div :class="$style.pageStatus">活动已结束</div>
      </div>
    </PullRefresh>
    <!-- 预约提示弹窗 -->
    <transition name="fade">
      <div :class="$style.dialogMask" v-if="orderDialogVisible">
        <div :class="$style.dialogContent">
          <h1>预约提示</h1>
          <img
            :src="`${cdnLink}/box_sign/close.png`"
            alt=""
            :class="$style.close"
            @click="onCloseOrderDialog"
          />
          <p :class="$style.label">
            游戏上线会通过短信通知您，<br />请在下方提交接收短信的手机号:
          </p>
          <div :class="$style.content" style="margin-top: 15px">
            <Field
              v-model.trim="inputMobile"
              placeholder="请输入手机号"
              :class="$style.field"
            ></Field>
          </div>
          <Button :class="$style.nextStep" @click="onSubmitMobile">提交</Button>
        </div>
      </div>
    </transition>
    <!-- 预约成功 -->
    <transition name="fade">
      <div :class="$style.dialogMask" v-if="orderSuccessVisible">
        <div :class="$style.dialogContent">
          <h1>预约成功</h1>
          <img
            :src="`${cdnLink}/box_sign/close.png`"
            alt=""
            :class="$style.close"
            @click="orderSuccessVisible = false"
          />
          <p :class="$style.labelTips">
            游戏上线将通过<span>{{ mobile }}</span
            >提醒您
          </p>
          <div :class="$style.orderContent" style="margin-top: 11.11px">
            <p>截图扫描二维码关注玩心不止手游<br />接收新游上线消息快人一步~</p>
            <img :src="subscribeDetail.vxCode" />
          </div>
        </div>
      </div>
    </transition>
    <!-- 领取礼包弹窗 -->
    <transition name="fade">
      <div :class="$style.dialogMask" v-if="receiveDialogVisible">
        <div :class="$style.dialogContent">
          <h1>{{ receiveTitle }}</h1>
          <img
            :src="`${cdnLink}/box_sign/close.png`"
            alt=""
            :class="$style.close"
            @click="onCloseReceiveOrderDialog"
          />
          <div v-if="receiveTitle === '领取验证'">
            <p :class="$style.label">
              请输入预约游戏时填写的手机号,<br />校验通过后即可获得礼包；
            </p>
            <div :class="$style.content" style="margin-top: 15px">
              <Field v-model.trim="receiveMobile" :class="$style.field"></Field>
            </div>
          </div>
          <div v-if="receiveTitle === '领取礼包成功'">
            <p :class="$style.label">
              恭喜获得【{{
                subscribeDetail.giftName
              }}】,<br />复制下方兑换码到游戏中兑换
            </p>
            <div :class="$style.codeContent" style="margin-top: 15px">
              礼包码：{{ giftInfo.cdk }}
            </div>
          </div>
          <div v-if="receiveTitle === '领取记录'">
            <p :class="$style.desc">【{{ subscribeDetail.giftName }}】</p>
            <p :class="$style.desc">
              礼包码：<span>{{ giftInfo.cdk }}</span>
            </p>
            <p :class="$style.desc">领取时间：{{ giftInfo.receiveTime }}</p>
          </div>

          <Button
            v-if="receiveTitle === '领取验证'"
            :class="$style.nextStep"
            @click="onSubmitGift"
            >提交</Button
          >
          <Button
            v-if="receiveTitle !== '领取验证'"
            :data-clipboard-text="giftInfo.cdk"
            :class="`${$style.nextStep} copySubscribeCdk`"
            @click="onCopy"
          >
            复制礼包码
          </Button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import { CDN_URL_1 } from "@/config";
import { onGoBack, setPageTitle } from "@/bridge/AppJsBridge";
import {
  activeDetail,
  subscribeGame,
  rewardGift,
} from "@/apis/btGameSubscribe";
import { Field, PullRefresh } from "vant";
import SectionTitle from "../components/SectionTitle";
import Clipboard from "clipboard";
import {
  getCookie,
  downloadTarget,
  checkIsWxBrowser,
  pageLoseTips,
} from "@/libs/utils";
import moment from "moment";
import { sendPoint } from "@/apis/btBoxActivity";

export default {
  name: "",
  components: {
    SectionTitle,
    Field,
    PullRefresh,
  },
  data() {
    return {
      cdnLink: CDN_URL_1,
      subscribeDetail: { status: 2 },
      orderDialogVisible: false,
      orderSuccessVisible: false,
      mobile: null, // 缓存手机
      inputMobile: null, // 预约填写手机
      receiveMobile: null, // 领取礼包手机
      isWeChat: false,
      hiddenTitle: false,
      receiveDialogVisible: false,
      receiveTitle: "领取验证",
      giftInfo: null,
      cookie: null,
      showDownLoadApp: true,
      pid: null,
      isLoading: false,
    };
  },
  computed: {
    formatOnlineTime: function () {
      const { onlineTime } = this.subscribeDetail;
      let time;
      if (onlineTime) {
        time = onlineTime.split(" ")[0].split("-");
        return `${time[0]}年${time[1]}月${time[2]}日`;
      }
      return null;
    },
    pageTitle: function () {
      return `游戏预约-${this.subscribeDetail.appName}`;
    },
  },

  created() {
    // 页面初始化
    inithandler();
    this.initPageData();
  },
  activated() {
    setPageTitle(this.pageTitle);
  },
  mounted() {
    this.copy = new Clipboard(".copySubscribeCdk");
  },

  methods: {
    // 下拉刷新
    async onRefresh() {
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event);
      if (!this.cookie) {
        return
      }
      console.log("event: ", data.event);
      sendPoint({
        ...this.cookie,
        ...data,
      }).catch((err) => console.log(err));
    },

    // 获取cookie、缓存等携带的用户信息数据
    async initPageData() {
      const { id } = this.$route.query;
      if (!id || isNaN(id)) {
        pageLoseTips(this.$toast);
        return;
      }
      this.pid = id;
      //  获取游戏预约活动配置详情
      await this.getActiveDetail(id);
      setPageTitle(this.pageTitle);
      const pageCookie = getCookie();
      const token = getCookie("token");

      if (token) {
        localStorage.setItem("token", token);
      }
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        const { userId } = pageCookie;
        this.cookie = pageCookie;
        if (userId) {
          //
        } else {
          await this.getMobileStorage();
        }
      } else {
        await this.getMobileStorage();
      }
      this.checkHasPageTitle();
    },

    // 判断是否需要隐藏标题拦
    checkHasPageTitle() {
      if (checkIsWxBrowser()) {
        this.hiddenTitle = true;
      }
      if (this.cookie) {
        this.hiddenTitle = true;
        this.showDownLoadApp = false;
      }
    },

    // 获取缓存
    async getMobileStorage() {
      let info = window.localStorage.getItem(
        `bt.order.mobile_${this.subscribeDetail.id}`
      );
      if (info) {
        this.mobile = JSON.parse(info);
      }
      let gift = localStorage.getItem(
        `bt.order.game.gift_${this.subscribeDetail.id}_${this.mobile}`
      );
      if (gift) {
        const { cdk, receiveTime } = JSON.parse(gift);
        this.giftInfo = { cdk, receiveTime };
      }
    },

    // 获取预约游戏活动
    async getActiveDetail(id) {
      await activeDetail(id).then((res) => {
        this.subscribeDetail = res.data;
        let event = "appointment_page";
        if (res.data.gameStatus) {
          event = "appointment_online_page";
        }
        this.eventTrack({
          event: event,
          event_field: JSON.stringify({
            activity_id: res.data.id,
            activity_name: res.data.activeName,
          }),
        });
      });
    },

    // 预约游戏
    onOpenOrderDialog(type) {
      if (!this.mobile) {
        this.eventTrack({
          event: "appointment_above_click",
          event_field: JSON.stringify({
            activity_id: this.subscribeDetail.id,
            activity_name: this.subscribeDetail.activeName,
            scene_type: type,
          }),
        });
        this.orderDialogVisible = true;
        this.eventTrack({
          event: "appointment_remind",
          event_field: JSON.stringify({
            activity_id: this.subscribeDetail.id,
            activity_name: this.subscribeDetail.activeName,
          }),
        });
      }
    },
    onCloseOrderDialog() {
      this.orderDialogVisible = false;
      this.inputMobile = null;
    },
    // 提交手机
    onSubmitMobile() {
      this.eventTrack({
        event: "appointment_remind_click",
        event_field: JSON.stringify({
          activity_id: this.subscribeDetail.id,
          activity_name: this.subscribeDetail.activeName,
        }),
      });

      if (this.inputMobile && !this.checkMobile(this.inputMobile)) {
        this.$toast("请填写正确的手机号");
        return;
      } else if (!this.inputMobile) {
        this.$toast("请填写手机号");
        return;
      }
      subscribeGame({
        id: this.subscribeDetail.id,
        mobile: this.inputMobile,
      }).then((res) => {
        this.nextOrderDialog();
        this.mobile = res.data.mobile;
        localStorage.setItem(
          `bt.order.mobile_${this.subscribeDetail.id}`,
          res.data.mobile
        );
        this.onCloseOrderDialog();
      });
    },

    checkMobile(mobile) {
      let res = true;
      if (mobile) {
        res = new RegExp(/^1\d{10}$/).test(mobile);
      }
      return res;
    },

    nextOrderDialog() {
      this.orderSuccessVisible = true;
      this.eventTrack({
        event: "appointment_success",
        event_field: JSON.stringify({
          activity_id: this.subscribeDetail.id,
          activity_name: this.subscribeDetail.activeName,
        }),
      });
    },

    // 关闭页面
    closePage() {
      onGoBack();
    },

    // 下载bt手游
    onDownloadWX() {
      this.eventTrack({
        event: "appointment_load_box",
        event_field: JSON.stringify({
          activity_id: this.subscribeDetail.id,
          activity_name: this.subscribeDetail.activeName,
          scene: this.subscribeDetail.gameStatus,
        }),
      });
      if (checkIsWxBrowser()) {
        this.isWeChat = true;
        return;
      }
      downloadTarget(this.subscribeDetail.appUrl);
    },

    // 下载游戏
    onDownloadGame(type) {
      this.eventTrack({
        event: "appointment_online_download",
        event_field: JSON.stringify({
          activity_id: this.subscribeDetail.id,
          activity_name: this.subscribeDetail.activeName,
          scene_type: type,
        }),
      });
      if (checkIsWxBrowser()) {
        this.isWeChat = true;
        return;
      }
      downloadTarget(this.subscribeDetail.downloadUrl);
    },

    // 跳转公告
    onJumpLink(pathName, data) {
      this.eventTrack({
        event: "appointment_notice_scan",
        event_field: JSON.stringify({
          activity_id: this.subscribeDetail.id,
          activity_name: this.subscribeDetail.activeName,
          scene: this.subscribeDetail.gameStatus,
        }),
      });
      this.$router.push({
        name: `box.${pathName}`,
        query: {
          data: data,
          title: pathName === "btNoticeList" ? "公告列表" : "公告详情",
          activeName: this.subscribeDetail.activeName,
        },
      });
    },

    //领取礼包
    onReceiveGift() {
      let event = "appointment_online_receive";
      if (this.giftInfo) {
        this.receiveTitle = "领取记录";
        event = "appointment_online_has_received";
      } else {
        this.receiveTitle = "领取验证";
      }
      this.eventTrack({
        event: event,
        event_field: JSON.stringify({
          activity_id: this.subscribeDetail.id,
          activity_name: this.subscribeDetail.activeName,
        }),
      });
      if (!this.giftInfo) {
        this.eventTrack({
          event: "appointment_online_check",
          event_field: JSON.stringify({
            activity_id: this.subscribeDetail.id,
            activity_name: this.subscribeDetail.activeName,
          }),
        });
      }else{
        this.eventTrack({
          event: 'appointment_online_record',
          event_field: JSON.stringify({
            activity_id: this.subscribeDetail.id,
            activity_name: this.subscribeDetail.activeName,
          }),
        });
      }
      this.receiveDialogVisible = true;
    },
    onSubmitGift() {
      this.eventTrack({
        event: "appointment_online_check_submit",
        event_field: JSON.stringify({
          activity_id: this.subscribeDetail.id,
          activity_name: this.subscribeDetail.activeName,
        }),
      });
      if (this.receiveMobile && !this.checkMobile(this.receiveMobile)) {
        this.$toast("请填写正确的手机号");
        return;
      } else if (!this.receiveMobile) {
        this.$toast("请填写手机号");
        return;
      }
      let params = {
        id: this.subscribeDetail.id,
        mobile: this.receiveMobile,
      };
      rewardGift(params).then((res) => {
        this.giftInfo = res.data;
        localStorage.setItem(
          `bt.order.game.gift_${this.subscribeDetail.id}_${params.mobile}`,
          JSON.stringify(res.data)
        );
        this.receiveTitle = res.data.isReceive ? "领取记录" : "领取礼包成功";
        let event = "appointment_online_gift_success";
        if (res.data.isReceive) {
          event = "appointment_online_record";
        }
        this.eventTrack({
          event: event,
          event_field: JSON.stringify({
            activity_id: this.subscribeDetail.id,
            activity_name: this.subscribeDetail.activeName,
          }),
        });
      });
    },
    onCloseReceiveOrderDialog() {
      this.receiveDialogVisible = false;
    },
    // 复制礼包码
    onCopy() {
      let event = "appointment_online_gift_copy";
      if (this.receiveTitle == "领取记录") {
        event = "appointment_online_record_copy";
      }
      this.eventTrack({
        event: event,
        event_field: JSON.stringify({
          activity_id: this.subscribeDetail.id,
          activity_name: this.subscribeDetail.activeName,
        }),
      });
      this.copy.on("success", () => {
        this.$toast("复制成功");
      });
      this.onCloseReceiveOrderDialog();
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.vipPage {
  width: 100%;
  height: calc(100vh - 65px);
  max-width: 375px;
  margin: auto;
  background: #f1f1f1;
  padding-top: 46px;
  // padding-bottom: 80px;
  overflow: auto;
  &.hiddenTitle {
    padding-top: 0px;
    > header {
      display: none;
    }
    .download {
      top: 0px;
    }
  }
  > header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: 375px;
    margin: auto;
    z-index: 3;
    background: #ffffff;
    color: #000000;
    font-size: 19px;
    padding: 14px 5px 14px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      font-weight: bold;
      position: absolute;
    }
    > span {
      font-size: 18px;
      font-weight: 700;
      margin: 0 auto;
    }
    :global {
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }
  .download {
    position: fixed;
    z-index: 1;
    top: 46px;
    width: 375px;
    height: 56px;
    display: flex;
    align-items: center;
    padding: 0 11.81px 0 15.77px;
    background: linear-gradient(to right, #feefd5 0%, #fedb9e 100%);
    img {
      width: 40px;
      margin-right: 6px;
    }
    p {
      height: px;
      font-size: 14px;
      font-weight: 400;
      color: #9b6c45;
    }
  }
  .wxGuide {
    width: 100%;
    z-index: 10;
  }
  .pageBg {
    position: relative;
    > img {
      width: 100%;
      height: calc(100vh - 52px);
    }
  }
  .pageMt {
    margin-top: 56px;
  }
  .pageStatus {
    width: 375px;
    height: 39.24px;
    line-height: 39.24px;
    position: absolute;
    top: calc(50% - 39px);
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    font-size: 18.75px;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.1),
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.1)
    );
    letter-spacing: 1px;
  }

  .gameBox {
    padding: 6px 0 0 0;
    height: 174px;
    position: relative;
    .gameListMask {
      background-size: cover;
      position: absolute;
      width: 100%;
      height: 174px;
      top: 0;
    }
    .gameInfo {
      position: absolute;
      display: flex;
      width: 361.11px;
      height: 72.22px;
      background: #ffffff;
      border-radius: 6.94px;
      box-shadow: -0.35px 0px 7.29px 0.35px rgba(0, 0, 0, 0.03);
      bottom: -36px;
      left: 0;
      margin: 0 auto;
      right: 0;
      align-items: center;
      padding: 0 11px;
      justify-content: space-between;
      .hot {
        width: 32px;
        margin-top: 2px;
      }
      .img {
        width: 58px;
        height: 58px;
        margin-right: 5.9px;
      }
      .title {
        color: #000000;
        font-weight: 500;
        font-size: 16px;
        text-align: left;
      }
      .num {
        background-image: linear-gradient(180deg, #f26200 0%, #e92900 100%);
        -webkit-background-clip: text;
        font-weight: 400;
        color: transparent;
        font-size: 10px;
        -webkit-transform: scale(0.92);
        transform-origin: center top;
        display: inline-block;
      }
      .btn {
        width: 79.51px;
        height: 25px;
        line-height: 25px;
        background: linear-gradient(0deg, #fcbb19 0%, #ffcc56 100%);
        border-radius: 12.5px;
        box-shadow: -3.82px 0px 5.56px 3.82px rgba(255, 201, 77, 0.36);
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        font-size: 11.46px;
      }

      .wrapper {
        flex: 1;
      }
    }
  }
  .disableBtn {
    filter: grayscale(100%);
  }
  .detailInfo {
    margin-top: 51px;
  }
  .timeBox {
    display: flex;
    margin: 0 18px 0;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #9f9f9f;
    padding-bottom: 10px;
    .iconImg {
      width: 16px;
    }
    .desc {
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #9f9f9f;
      margin-left: 6px;
      // -webkit-transform: scale(.92);
      // transform-origin: left;
      flex: 1;
    }
    .day {
      font-size: 12px;
      // -webkit-transform: scale(.8);
      // font-size: 10.07px;
      font-weight: 400;
      color: #c10000;
      transform-origin: right;
    }
  }
  .noticeBox {
    display: flex;
    margin: 0 18px 15px;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
    .iconImg {
      width: 16px;
    }
    .desc {
      margin-left: 2px;
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #9f9f9f;
      // -webkit-transform: scale(.8);
      // transform-origin: left;
      flex: 1;
      margin-left: 6px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .allNotice {
      // -webkit-transform: scale(.8);
      font-size: 12px;
      font-weight: 400;
      color: #1b97f7;
      text-decoration: underline;
      // transform-origin: right;
    }
  }
  .flex_1 {
    flex: 1;
  }
  .pageContent {
    background: #ffffff;
    margin-top: 4px;
    padding: 15.34px 17.36px 10.65px;
    .giftHeader {
      display: flex;
      align-items: center;
      > img {
        width: 60px;
        margin-right: 7.29px;
      }
      .name {
        font-size: 14.58px;
        font-weight: 500;
        color: #000000;
        margin-bottom: 8px;
      }
      .desc {
        font-size: 12.5px;
        font-weight: 400;
        color: #9f9f9f;
      }
      .btn {
        width: 79.51px;
        height: 25px;
        background: linear-gradient(0deg, #fe9a66 0%, #feaa7c 100%);
        border-radius: 12.5px;
        box-shadow: -3.82px 0px 5.56px 3.82px rgba(253, 155, 103, 0.36);
        font-size: 11.46px;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 26px;
      }
    }
    .giftTitle {
      font-size: 14.58px;
      font-weight: 500;
      text-align: center;
      color: #555555;
      padding: 0 4px;
      display: inline-block;
      border-left: 1.9px solid #555555;
      margin-top: 13px;
    }
    .giftContent {
      margin-top: 10px;
      width: 100%;
      line-height: 1.5;
      font-size: 12px;
      margin-bottom: 15px;
      img {
        width: 100%;
      }
    }
    .gameImages {
      width: 100%;
      overflow: auto;
      display: flex;
      justify-content: flex-start;
      margin-top: 10px;
      .image {
        width: 106.25px;
        height: 188.54px;
        border-radius: 6.94px;
        margin-right: 6px;
      }
      .imageL {
        width: 300px;
        // height: 106.25px;
        border-radius: 6.94px;
        margin-right: 10px;
      }
    }
  }
  .footerBtn {
    width: 252.08px;
    height: 41.67px;
    position: fixed;
    bottom: 10px;
    margin: 0 auto;
    left: 0;
    right: 0;
    background: linear-gradient(0deg, #fcbb19 0%, #ffcc56 100%);
    border-radius: 20.83px;
    box-shadow: -3.82px 0px 5.56px 3.82px rgba(255, 201, 77, 0.36);

    font-size: 19.1px;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    line-height: 41.67px;
  }
  .dialogMask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 2;
  }
  .dialogContent {
    width: 300px;
    border-radius: 12px;
    overflow: hidden;
    background: #ffffff;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    margin: auto;
    padding-bottom: 21px;
    .close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 18px;
    }
    > h1 {
      width: 100%;
      height: 41px;
      text-align: center;
      background-color: #ffb017;
      color: #ffffff;
      font-size: 17px;
      font-weight: bold;
      // border-radius: 6px;
      line-height: 41px;
    }
    .label {
      width: 188.89px;
      font-size: 13.19px;
      font-weight: 500;
      text-align: left;
      color: #222222;
      line-height: 21.88px;
      margin: 40px auto 0;
    }
    .desc {
      width: 210px;
      font-size: 13.19px;
      font-weight: 500;
      text-align: left;
      color: #222222;
      line-height: 21.88px;
      margin: 7px auto 0;
      > span {
        font-weight: 500;
        color: #2a00ff;
      }
    }
    .desc:first-child {
      margin-top: 40px;
    }
    .codeContent {
      width: 225.69px;
      height: 34.72px;
      background: #f2f2f2;
      border-radius: 6.94px;
      border: none;
      text-align: center;
      line-height: 34.72px;
      margin: auto;
      font-weight: 500;
      color: #2a00ff;
      font-size: 13.19px;
    }
    .labelTips {
      font-size: 13.19px;
      font-weight: 500;
      text-align: center;
      color: #222222;
      line-height: 21.88px;
      margin-top: 15px;
      > span {
        color: rgb(255, 176, 23);
        font-size: 13.19px;
        font-weight: 500;
      }
    }

    .orderContent {
      width: 258.33px;
      height: 197.57px;
      background: #f2f2f2;
      margin: 0 auto;
      text-align: center;
      padding: 10px 0 11px;
      img {
        width: 126px;
        margin-top: 8px;
      }
      p {
        width: 202px;
        font-size: 13.19px;
        font-weight: 500;
        text-align: left;
        color: #222222;
        line-height: 21.88px;
        margin: auto;
      }
    }

    .content {
      width: 225.69px;
      background: #f2f2f2;
      border-radius: 6.94px;
      display: flex;
      align-items: center;
      padding: 4px;
      margin: 30px auto;
      > p {
        color: #cdcdcd;
        font-size: 14px;
      }
      .field {
        border: none;
        padding: 0px 18px;
        background: transparent;
        width: 100%;
        height: 26px;
        :global {
          input {
            color: #7c7c7c;
          }
        }
      }
      :global {
        .yw-select-wrap {
          width: 100%;
          background-color: #e0e0e0;
          color: #888585;
        }
      }
    }
    .nextStep {
      margin: auto;
      width: 208px;
      height: 38px;
      line-height: 38px;
      border: none;
      border-radius: 38px;
      background: #ffb017;
      color: #ffffff;
      display: block;
      margin-top: 20px;
    }
    .giftDesc {
      font-size: 17.36px;
      font-weight: 700;
      text-align: center;
      color: #999999;
      width: 253.13px;
      margin: 29px auto 20px;
      line-height: 20px;
    }

    .giftCode {
      width: 151px;
      color: #999999;
      text-align: left;
      font-size: 13.19px;
      font-weight: 500;
      display: block;
      margin: auto;
      line-height: 20px;
      p:first-child {
        text-align: center;
        font-size: 15.97px;
      }
    }
    .giftBtn {
      width: 232.64px;
      height: 34.72px;
      background: #ffb017;
      border-radius: 17.36px;
      margin: 20px auto 0;
      font-size: 13.89px;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
      line-height: 12.5px;
      display: block;
    }

    .rule {
      color: #999999;
      font-size: 12px;
      text-align: left;
      padding: 10px;
      line-height: 16px;
    }
    .indicator {
      text-align: center;
      color: #999999;
      font-size: 11.11px;
      margin-top: 19px;
    }
  }
}
</style>
